import { Injectable } from '@angular/core';
import { App } from '@app/core/app';
import { FacadeService } from '@app/services/facade.service';
import { SharedDataService } from '@app/services/shared/shared-data.service';
import * as signalR from "@microsoft/signalr";
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class SignalrService {

 // public data;
  public hubConnection: signalR.HubConnection
  userId: string;
  roleNames: any;
  count: number;

  constructor(private toastr: ToastrService, private facadeService: FacadeService,
    private dataSharingService: SharedDataService) { 
    if (this.facadeService.accountService.isLoggedIn) {
      this.userId = this.facadeService.accountService.user.id;
      this.roleNames = this.facadeService.accountService.user.roleNames;
    }
  }


  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${App.orderServiceUrl}/signalRNotification`, {
         skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
          accessTokenFactory: () => `${this.userId},${this.roleNames}`
        })
      .build();
    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }
  
  notifyAdminWhenNewInternationalOrderPaidListener() {
    this.hubConnection.on('ReceiveMessage', (message) => {
      this.getUnReadCount();
      this.toastr.success(message);
    })
  }

  getUnReadCount() {
    this.facadeService.adminFacadeService.notifacationService.getUnReadCountOfInternationalOrdersNotifications()
      .subscribe(res => {
        this.count = res;
        this.dataSharingService.unReadInternationalOrderNotificationCount.next(this.count);
      });
  }

  public closeConnection() {
    this.hubConnection.off("ReceiveMessage");
  }

}